<div class="landing-about">
    <app-section-first></app-section-first>
    <app-section-second></app-section-second>
    <app-section-third></app-section-third>
</div>
<app-footer-all [brand]="brand"></app-footer-all>